// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider{
    position: relative;
    overflow: hidden;
    width: 100vw;
    height:100vh;
}

.slider h1{
  display: none;
}

.slide.flex:nth-child(1) .slide-image img{
  margin-top: -10%;
  /* margin-left: 130px; */
  width:26vw;
  height: auto;
}

.slide.flex:nth-child(2) .slide-image img{
  margin-top: 5%;
  /* margin-left: 40px; */
  width:32vw;
  height: auto;
}

.slide.flex:nth-child(3) .slide-image img{
  margin-top: -10%;
  width:25vw;
  /* margin-left: 80px; */
  height: auto;
}

.slide.flex:nth-child(4) .slide-image img{
  margin-top: 6%;
  width:30vw;
  height: auto;
}

.slide.flex:nth-child(5) .slide-image img{
  margin-top: 6%;
  width:30vw;
  height: auto;
}

.slide.flex:nth-child(6) .slide-image img{
  margin-top: 6%;
  width:31vw;
  /* margin-left: 30px; */
  height: auto;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  /* background-color: aqua; */
}

.slider-wrapper div {
  position: relative;
  text-align: justify;
  /* background-color: black; */
}

.slider-wrapper {
  margin-top: 7vw;
  margin-left: 15vw;
}

.slide-image {
  height: 24vw;
}

.slide-image img {
  width: 24vw;
}

.slide-content {
  width: 25vw;
  color: var(--text-color);
  font-weight: 700;
  padding: 3vw 18vw 3vw 9vw;
}

.slide-date {
  color: var(--text-color);
  font-size: 1.5vw;
  font-weight: 400;
  letter-spacing: 0.1vw;
  padding-bottom: 1.4vw;
}

.slide-title {
  color: var(--main-color);
  font-size: 1.8vw;
  font-weight: 400;
  letter-spacing: 0.1vw;
  line-height: 1.55vw;
  padding-bottom: 1.8vw;
}

.slide-text {
  font-size: 0.8vw;
  line-height: 1.2vw;
  opacity: 0.8;
  padding-bottom: 4vw;
}



.slide-bullet {
  width: 0.5vw;
  height: 0.5vw;
  background-color: var(--main-color);
  border-radius: 200%;
  position: relative;
  margin-left: 1.2vw;
}

.slide-nav {
  margin-left: 64vw;
  margin-top: -5.5vw;
}

div.overlay-blue {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  transition: 0.5s ease all;
}

div.overlay-blue:hover {
  background-color: rgba(13, 27, 43, 0.5);
}

.arrows {
  width: 3.5vw;
  margin-top: -5.8vw;
  margin-left: 72vw;
  position: relative;
}

.arrow {
  display: inline-block;
  position: absolute;
  width: 1.2vw;
  height: 1.2vw;
  background: transparent;
  text-indent: -9999px;
  box-shadow: 0 0 0.8rem var(--main-color);
  border-top: 0.25vw solid var(--text-color);
  border-left: 0.25vw solid var(--text-color);
  border-right: 0.25vw solid var(--bg-color);
  border-bottom: 0.25vw solid var(--bg-color);
  transition: all 0.1s ease-in-out;
  text-decoration: none;
  color: transparent;
  cursor: pointer;
}

.arrow:hover {
  border-color: var(--main-color);
  border-width: 0.25vw;
}

.arrow:before {
  display: block;
  height: 200%;
  width: 200%;
  margin-left: -50%;
  margin-top: -50%;
  content: "";
  transform: rotate(45deg);
}

.arrow.prev {
  transform: rotate(-45deg);
  left: -10px;
}

.arrow.next {
  transform: rotate(135deg);
  right: -10px;
}

@media(max-width:998px){

  .slider{
    align-items: center;
    display: flex;
    flex-direction: column;
    height: -moz-fit-content;
    height: fit-content;
  }

  .slide.flex:nth-child(1) .slide-image img{
    width:70vw;
  }
  
  .slide.flex:nth-child(2) .slide-image img{
    width:70vw;
  }
  
  .slide.flex:nth-child(3) .slide-image img{
    width:70vw;
  }
  
  .slide.flex:nth-child(4) .slide-image img{
    width:70vw;
  }
  
  .slide.flex:nth-child(5) .slide-image img{
    width:70vw;
  }
  
  .slide.flex:nth-child(6) .slide-image img{
    width:70vw;
  }

  .slider h1{
    /* text-align: center; */
    display: flex;
    width: -moz-fit-content;
    width: fit-content;
    position: relative;
    font-size: 1.9rem;
    margin-top: 20vw;
    }

    .slide-content{
      margin-top: 65%;
      margin-left: -70%;
      width: 100px;
    }

  .slider-wrapper {
    align-self: flex-start;
    margin-top: 20vw;
  }

  .slide-image {
    height: 60vw;
  }
  
  .slide-image img {
    width: 24vw;
  }


  .slide-date {
    width: 550px;
      font-size: 1.5rem;
      font-weight: 400;
      letter-spacing: 0.1vw;
      padding-bottom: 1.4vw;
    }
    
    .slide-title {
      width: 300px;
      font-size: 1.2rem;
      font-weight: 400;
      letter-spacing: 0.1vw;
      line-height: 5vw;
      padding-bottom: 1.8vw;
    }
    
    .slide-text {
      font-size: 0.8rem;
      line-height: normal;
      opacity: 0.9;
      width: 85vw;
      letter-spacing: normal;
      padding-bottom: 4vw;
    }
    .arrows {
      width: 15vw;
      margin-bottom: 2rem;
    }
    .arrow {
      width: 5vw;
      height: 5vw;
    }
    
  }`, "",{"version":3,"sources":["webpack://./src/components/About/Achievements/Achievements.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,YAAY;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,YAAY;AACd;;AAEA;EAEE,aAAa;EAEb,mBAAmB;EAEnB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;;;AAIA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,wCAAwC;EACxC,0CAA0C;EAC1C,2CAA2C;EAC3C,0CAA0C;EAC1C,2CAA2C;EAC3C,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE;IACE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,aAAa;IACb,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB;;IAEA;MACE,eAAe;MACf,iBAAiB;MACjB,YAAY;IACd;;EAEF;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,YAAY;MACV,iBAAiB;MACjB,gBAAgB;MAChB,qBAAqB;MACrB,qBAAqB;IACvB;;IAEA;MACE,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;MAChB,qBAAqB;MACrB,gBAAgB;MAChB,qBAAqB;IACvB;;IAEA;MACE,iBAAiB;MACjB,mBAAmB;MACnB,YAAY;MACZ,WAAW;MACX,sBAAsB;MACtB,mBAAmB;IACrB;IACA;MACE,WAAW;MACX,mBAAmB;IACrB;IACA;MACE,UAAU;MACV,WAAW;IACb;;EAEF","sourcesContent":[".slider{\n    position: relative;\n    overflow: hidden;\n    width: 100vw;\n    height:100vh;\n}\n\n.slider h1{\n  display: none;\n}\n\n.slide.flex:nth-child(1) .slide-image img{\n  margin-top: -10%;\n  /* margin-left: 130px; */\n  width:26vw;\n  height: auto;\n}\n\n.slide.flex:nth-child(2) .slide-image img{\n  margin-top: 5%;\n  /* margin-left: 40px; */\n  width:32vw;\n  height: auto;\n}\n\n.slide.flex:nth-child(3) .slide-image img{\n  margin-top: -10%;\n  width:25vw;\n  /* margin-left: 80px; */\n  height: auto;\n}\n\n.slide.flex:nth-child(4) .slide-image img{\n  margin-top: 6%;\n  width:30vw;\n  height: auto;\n}\n\n.slide.flex:nth-child(5) .slide-image img{\n  margin-top: 6%;\n  width:30vw;\n  height: auto;\n}\n\n.slide.flex:nth-child(6) .slide-image img{\n  margin-top: 6%;\n  width:31vw;\n  /* margin-left: 30px; */\n  height: auto;\n}\n\n.flex {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n  flex-direction: row;\n  -webkit-justify-content: flex-start;\n  justify-content: flex-start;\n  /* background-color: aqua; */\n}\n\n.slider-wrapper div {\n  position: relative;\n  text-align: justify;\n  /* background-color: black; */\n}\n\n.slider-wrapper {\n  margin-top: 7vw;\n  margin-left: 15vw;\n}\n\n.slide-image {\n  height: 24vw;\n}\n\n.slide-image img {\n  width: 24vw;\n}\n\n.slide-content {\n  width: 25vw;\n  color: var(--text-color);\n  font-weight: 700;\n  padding: 3vw 18vw 3vw 9vw;\n}\n\n.slide-date {\n  color: var(--text-color);\n  font-size: 1.5vw;\n  font-weight: 400;\n  letter-spacing: 0.1vw;\n  padding-bottom: 1.4vw;\n}\n\n.slide-title {\n  color: var(--main-color);\n  font-size: 1.8vw;\n  font-weight: 400;\n  letter-spacing: 0.1vw;\n  line-height: 1.55vw;\n  padding-bottom: 1.8vw;\n}\n\n.slide-text {\n  font-size: 0.8vw;\n  line-height: 1.2vw;\n  opacity: 0.8;\n  padding-bottom: 4vw;\n}\n\n\n\n.slide-bullet {\n  width: 0.5vw;\n  height: 0.5vw;\n  background-color: var(--main-color);\n  border-radius: 200%;\n  position: relative;\n  margin-left: 1.2vw;\n}\n\n.slide-nav {\n  margin-left: 64vw;\n  margin-top: -5.5vw;\n}\n\ndiv.overlay-blue {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  transition: 0.5s ease all;\n}\n\ndiv.overlay-blue:hover {\n  background-color: rgba(13, 27, 43, 0.5);\n}\n\n.arrows {\n  width: 3.5vw;\n  margin-top: -5.8vw;\n  margin-left: 72vw;\n  position: relative;\n}\n\n.arrow {\n  display: inline-block;\n  position: absolute;\n  width: 1.2vw;\n  height: 1.2vw;\n  background: transparent;\n  text-indent: -9999px;\n  box-shadow: 0 0 0.8rem var(--main-color);\n  border-top: 0.25vw solid var(--text-color);\n  border-left: 0.25vw solid var(--text-color);\n  border-right: 0.25vw solid var(--bg-color);\n  border-bottom: 0.25vw solid var(--bg-color);\n  transition: all 0.1s ease-in-out;\n  text-decoration: none;\n  color: transparent;\n  cursor: pointer;\n}\n\n.arrow:hover {\n  border-color: var(--main-color);\n  border-width: 0.25vw;\n}\n\n.arrow:before {\n  display: block;\n  height: 200%;\n  width: 200%;\n  margin-left: -50%;\n  margin-top: -50%;\n  content: \"\";\n  transform: rotate(45deg);\n}\n\n.arrow.prev {\n  transform: rotate(-45deg);\n  left: -10px;\n}\n\n.arrow.next {\n  transform: rotate(135deg);\n  right: -10px;\n}\n\n@media(max-width:998px){\n\n  .slider{\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    height: fit-content;\n  }\n\n  .slide.flex:nth-child(1) .slide-image img{\n    width:70vw;\n  }\n  \n  .slide.flex:nth-child(2) .slide-image img{\n    width:70vw;\n  }\n  \n  .slide.flex:nth-child(3) .slide-image img{\n    width:70vw;\n  }\n  \n  .slide.flex:nth-child(4) .slide-image img{\n    width:70vw;\n  }\n  \n  .slide.flex:nth-child(5) .slide-image img{\n    width:70vw;\n  }\n  \n  .slide.flex:nth-child(6) .slide-image img{\n    width:70vw;\n  }\n\n  .slider h1{\n    /* text-align: center; */\n    display: flex;\n    width: fit-content;\n    position: relative;\n    font-size: 1.9rem;\n    margin-top: 20vw;\n    }\n\n    .slide-content{\n      margin-top: 65%;\n      margin-left: -70%;\n      width: 100px;\n    }\n\n  .slider-wrapper {\n    align-self: flex-start;\n    margin-top: 20vw;\n  }\n\n  .slide-image {\n    height: 60vw;\n  }\n  \n  .slide-image img {\n    width: 24vw;\n  }\n\n\n  .slide-date {\n    width: 550px;\n      font-size: 1.5rem;\n      font-weight: 400;\n      letter-spacing: 0.1vw;\n      padding-bottom: 1.4vw;\n    }\n    \n    .slide-title {\n      width: 300px;\n      font-size: 1.2rem;\n      font-weight: 400;\n      letter-spacing: 0.1vw;\n      line-height: 5vw;\n      padding-bottom: 1.8vw;\n    }\n    \n    .slide-text {\n      font-size: 0.8rem;\n      line-height: normal;\n      opacity: 0.9;\n      width: 85vw;\n      letter-spacing: normal;\n      padding-bottom: 4vw;\n    }\n    .arrows {\n      width: 15vw;\n      margin-bottom: 2rem;\n    }\n    .arrow {\n      width: 5vw;\n      height: 5vw;\n    }\n    \n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
